import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a8b09f9dd30bdbb155ac311b6eeb75f5db from "./generated-39ddc153-6960-4f7a-9013-dd6bda4fd903.json";

import a1b375d93ba5b84ba07c01b22999cca97b from "./generated-e8168ce3-b62c-49d1-830e-c11cf4ec71e0.json";

import a927052787b57dbcfb8fdd1a9f5c2e85cb from "./generated-c3cc56d7-3958-4d13-892e-d05d41179127.json";

import aebccb404e92f24f4eb2e843ef578dc10b from "./generated-71b0bec2-c8aa-4253-9368-c7d0e900405d.json";

import ac5a8762eb9822686d4d48cee17ab2204b from "./generated-0720a271-4bad-4150-8b24-0afe52e4edcb.json";

import ae82b38ccae4bc26202632f580abe35b9b from "./generated-00fccd74-791c-4117-9ca6-479215a3783e.json";

import af27646a56bb35c5aae3d3cbcc95c215eb from "./generated-60b78fbd-9eda-44c4-945b-061899dbef7f.json";

import a47a1ee9e9541611034f25f9ce9b22839b from "./generated-ce9f01d5-c293-4dcd-8343-9782ffe41066.json";

import a342fa000ba2814a292d498c89858198ab from "./generated-9c41103d-d1d2-4cd9-9776-9569f45731a8.json";

import a0482ea839826d96c6e7573f9b159682db from "./generated-f59f4340-acff-4d98-8cb0-bb250cb3607a.json";

import a109f3a164453b8cbd2652f6c9163545db from "./generated-fc9d07f9-2901-4f72-bf8d-b2d51d0556e0.json";

import a10fd53b14a2e14203f0a3ea95e4cc450b from "./generated-a51c32f4-c333-4d84-8fa5-d31d1c1984b8.json";

import a04364bd10874f84568dac787be5b485bb from "./generated-44e6d96a-0cfd-4a43-ba36-98794d95afaa.json";

import a5577186e1749e016097f5ceb9056c486b from "./generated-5da04094-7718-4e68-8b4c-1e69727ae2a7.json";

import aa04564d46f95f00cf1cd0dcbb21b2737b from "./generated-dabf0985-f4b8-4075-ba35-3e8895bfe9ec.json";

import a5e7851fbf4afa78d96d2a73f220cb426b from "./generated-5e78776f-000f-4b0a-a1d1-d5b992f889eb.json";

import a038fa7aa5f169915b342300eb245c187b from "./generated-1cbd274f-6dae-444a-ae32-8ef15b86423c.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a8b09f9dd30bdbb155ac311b6eeb75f5db);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1b375d93ba5b84ba07c01b22999cca97b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a927052787b57dbcfb8fdd1a9f5c2e85cb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aebccb404e92f24f4eb2e843ef578dc10b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ac5a8762eb9822686d4d48cee17ab2204b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ae82b38ccae4bc26202632f580abe35b9b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(af27646a56bb35c5aae3d3cbcc95c215eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a47a1ee9e9541611034f25f9ce9b22839b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a342fa000ba2814a292d498c89858198ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a0482ea839826d96c6e7573f9b159682db);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a109f3a164453b8cbd2652f6c9163545db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a10fd53b14a2e14203f0a3ea95e4cc450b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a342fa000ba2814a292d498c89858198ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a04364bd10874f84568dac787be5b485bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a5577186e1749e016097f5ceb9056c486b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a342fa000ba2814a292d498c89858198ab);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aa04564d46f95f00cf1cd0dcbb21b2737b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5e7851fbf4afa78d96d2a73f220cb426b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a038fa7aa5f169915b342300eb245c187b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aa04564d46f95f00cf1cd0dcbb21b2737b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */